//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import $ from 'jquery';
import axios from 'axios';

export default {
    layout: function layout(context) {
        return global.getTheme();
    },
    data: function data() {
        return {
            errorMessage: '',
            placeHolderMessage: '',
            geoCountryCode: '',
            type: 'all',
            searchText: '',
            loading: false,
            view: 'default'
        };
    },
    mounted: function mounted() {
        this.loadPhoneInput();
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    created: function created() {
        this.view = global.getTheme();
        if (process.client) {
            this.searchText = customSessionStorage.getItem('lastSearchText');
            if (customSessionStorage.getItem('lastSearchType') == 'phone') {}
            this.geoIpLookup(function (countryCode) {
                this.geoCountryCode = countryCode;
            }.bind(this));
        }
    },

    methods: {
        search: function search() {
            if ($('#phone').val().trim().length > 0 && this.validatePhoneInput() || this.validateSearchInput()) {

                var phoneNumber = $("#phone").intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
                $("#phone").val(phoneNumber);

                sessionStorage.setItem('lastSearchText', $('#first_name').val() + ' ' + $('#middle_name').val() + ' ' + $('#last_name').val());
                sessionStorage.setItem('lastSearchType', this.type);
                sessionStorage.setItem('first_name', $("#first_name").val());
                sessionStorage.setItem('middle_name', $("#middle_name").val());
                sessionStorage.setItem('last_name', $("#last_name").val());
                sessionStorage.setItem('phone', phoneNumber);
                sessionStorage.setItem('email', $("#email").val());
                //this.$parent.$emit('loading', true, $('#search_input').val());
                this.$router.push({
                    name: 'lang-search-results-type-search-loading',
                    params: {
                        lang: this.$route.params.lang,
                        search: $('#first_name').val() + ' ' + $('#middle_name').val() + ' ' + $('#last_name').val(),
                        type: this.type
                    }
                });
            }
        },
        validatePhoneInput: function validatePhoneInput() {
            var isValid = $("#phone").intlTelInput("isValidNumber");
            if (isValid) {
                return true;
            } else {
                this.errorMessage = this.$root.trans('st_public.invalid_phone_number');
            }
            return false;
        },
        validateSearchInput: function validateSearchInput() {
            var result = true;
            this.errorMessage = '';

            var searchText = $('#first_name').val() + $('#middle_name').val() + $('#last_name').val();

            if ($('#email').val().trim() != '') {
                var emailRegExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                if (!emailRegExp.test($('#email').val())) {
                    this.errorMessage = this.$root.trans('st_public.invalid_email_address');
                    result = false;
                }
            }
            if ($('#phone').val().trim() != '') {
                if (!intlTelInputUtils.isValidNumber(searchText, this.geoCountryCode)) {
                    this.errorMessage = this.$root.trans('st_public.invalid_phone_number');
                    result = false;
                }
            }
            if (searchText.trim() == '' && $('#phone').val().trim() == '' && $('#email').val().trim() == '') {
                result = false;
                this.errorMessage = this.$root.trans('st_public.empty_search_text');
            }
            return result;
        },
        getSearchType: function getSearchType() {
            return 'all';
        },
        geoIpLookup: function geoIpLookup(callback) {
            axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/common/geo-country').then(function (res) {
                var countryCode = res.data.country;
                callback(countryCode);
            });
        },
        loadPhoneInput: function loadPhoneInput() {
            $(".searchText").css({ 'display': 'inline-block', 'direction': 'ltr' });
            if (process.client) {
                require('intl-tel-input');

                $("#phone").intlTelInput({
                    initialCountry: 'auto',
                    geoIpLookup: this.geoIpLookup
                    //, utilsScript: "/js/utils.js"
                });
                $('#phone').css('text-align', 'right');
                $('#phone').css('direction', 'ltr');
                $('.intl-tel-input').addClass('form-control-lg');
                $('.intl-tel-input').addClass('form-control');
                $('.intl-tel-input').addClass('border');
                $('.intl-tel-input').addClass('border-primary');
                $('.intl-tel-input').css('padding', 0);
                $('.intl-tel-input .form-control').css('border', 0);
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/no-result/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/no-result/index.vue
// module chunks = 23